import { Zap } from 'lucide-react';
import type { CustomerStatus } from '../../types';

interface CustomerStatusBadgeProps {
  status: CustomerStatus;
  size?: 'sm' | 'md';
}

const LABEL: Record<CustomerStatus, string> = {
  PROSPECT: 'Prospect',
  ONBOARDED: 'Onboarded',
  ACTIVE: 'Active',
  SLIPPING: 'At Risk',
  LAPSED: 'Lapsed',
};

const COLOR: Record<CustomerStatus, string> = {
  PROSPECT: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  ONBOARDED: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  ACTIVE: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  SLIPPING: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  LAPSED: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};

const TOOLTIP: Record<CustomerStatus, string> = {
  PROSPECT: 'Not on the Blast platform.',
  ONBOARDED: 'Registered with Blast — no fundraiser launched yet.',
  ACTIVE: 'Launched a fundraiser in the current school year.',
  SLIPPING: 'At Risk — last fundraiser was in the prior school year. Needs re-engagement.',
  LAPSED: 'No fundraisers in the current or prior school year.',
};

export const CustomerStatusBadge = ({ status, size = 'sm' }: CustomerStatusBadgeProps) => {
  const showIcon = size === 'md' && status === 'ACTIVE';
  return (
    <span
      title={TOOLTIP[status]}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${COLOR[status]}`}
    >
      {showIcon && <Zap className="h-3 w-3 mr-0.5" />}
      {LABEL[status]}
    </span>
  );
};
